<!-- 快捷回复模板 -->
<template>
  <div class="reply-content">
    <div>
        <div class="header">
            <i class="el-icon-back mr-10" @click="goBack"></i>
            <strong>{{status === 'detail' ? '快捷回复':'编辑'}}</strong>
            <i v-if="status === 'detail'" class="el-icon-s-tools" style="float:right" @click="editClick"></i>
            <span v-if="status === 'edit'" style="float:right">
                <el-button style="padding:0" type="text" @click="handleAdd">新增回复</el-button>
                <el-button type="primary" size="mini" @click="finish">完成</el-button>
            </span>
        </div>
        <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="个人常用" name="1">
                <div v-if="textList && textList.length>0" class="box1">
                    <div class="one-bar" v-for="(item) in textList" :key="item.id">
                        <i v-if="status === 'edit'" class="el-icon-remove color-red" @click="deleteItem(item)"></i>
                        <!-- <el-button v-if="status === 'detail'" type="success" size="mini" @click="addClick(item)">发送</el-button> -->
                        <span @click="addClick(item)">{{item.content}}</span>
                        <i v-if="status === 'edit'" class="el-icon-menu color-gray"></i>
                    </div>
                </div>
                <div v-else style="text-align:center">
                    <el-image style="max-width: 300px;" src="../../../static/empty.png"></el-image>
                    <div style="font-size: 20px;color: #a4a4a4;">没有数据请添加</div>
                </div>
            </el-tab-pane>
            <el-tab-pane label="公共常用" name="0">
                <div v-if="textList && textList.length>0" class="box2">
                    <div class="one-bar" v-for="(item) in textList" :key="item.id">
                        <i v-if="status === 'edit'" class="el-icon-remove color-red" @click="deleteItem(item)"></i>
                        <!-- <el-button v-if="status === 'detail'" type="success" size="mini" @click="addClick(item)">发送</el-button> -->
                        <span @click="addClick(item)">{{item.content}}</span>
                        <i v-if="status === 'edit'" class="el-icon-menu color-gray"></i>
                    </div>
                </div>
                <div v-else style="text-align:center">
                    <el-image style="max-width: 300px;" src="../../../static/empty.png"></el-image>
                    <div style="font-size: 20px;color: #a4a4a4;">没有数据请添加</div>
                </div>
            </el-tab-pane>
        </el-tabs>
    </div>
    <div class="editContent" v-if="showEdit">
        <div class="header mb-10">
            <i class="el-icon-back mr-10" @click="addBack"></i>
            <strong>{{status === 'add' ? '添加':'编辑'}}快捷回复</strong>
            <el-button style="float:right" size="mini" type="primary" @click="save">完成</el-button>
        </div>
        <div>
            <el-input v-model="inputReply" type="textarea" :rows="5" placeholder="输入快捷回复..."></el-input>
            <div class="mt-10">
                <span>所属分组：</span>
                <el-select v-model="group" size="mini" placeholder="所属分组">
                <el-option label="个人常用" :value="1"></el-option>
                <el-option label="企业常用" :value="0"></el-option>
                </el-select>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import {deleteReply, addReply, editReply, getReply} from '../../api/appletApi.js'
import Sortable from 'sortablejs'
export default {
  name: '',
  mixins: [],
  components: {},
  props: {
    replyShow: {
      Boolean,
      default: false
    },
    myUserId: {
      String,
      default: ''
    }
  },
  data () {
    return {
      activeName: '1',
      textList: [],
      showEdit: false,
      group: 1, // 所属分组
      status: 'detail',
      currentRow: {},
      inputReply: ''
    }
  },
  watch: {},
  computed: {},
  created () {},
  mounted () {
    this.getList()
  },
  methods: {
    initSort (cls) {
      if (this.sortObj) {
        this.sortObj.destroy()
        this.sortObj = null
      }
      let el1 = document.querySelector(cls)
      this.sortObj = Sortable.create(el1, {
        handle: '.color-gray', // handle's class
        onEnd: ({newIndex, oldIndex}) => {
          const data = this.textList.splice(oldIndex, 1)[0]
          this.textList.splice(newIndex, 0, data)

          let params = {
            id: data.id, // 主键
            content: data.content, // 内容
            templateType: data.templateType, // 类型，0：公共，1：私有
            templateSort: newIndex + 1 // 排序
          }
          editReply(params)
        }
      })
    },
    getList () { // 获取快捷回复
      this.textList = []
      let params = {
        page: 1,
        size: 999,
        templateType: this.activeName,
        userId: this.myUserId
      }
      getReply(params).then(data => {
        this.textList = data.list
      })
    },
    handleClick () { // tab切换
      this.getList()
    },
    editClick () { // 编辑
      this.status = 'edit'
      if (this.activeName === '1') {
        this.$nextTick(() => {
          this.initSort('.box1')
        })
      } else {
        this.$nextTick(() => {
          this.initSort('.box2')
        })
      }
    },
    addClick (val) { // 选择语句
      if (this.status === 'edit') { // 编辑
        this.showEdit = true
        this.inputReply = val.content
        this.currentRow = val
        this.group = val.templateType
      } else {
        this.$confirm('需要使用当前快捷语句吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$emit('chooseText', val.content)
          this.goBack()
        }).catch(() => {
          this.$message.info('已取消')
        })
      }
    },
    goBack () {
      this.$emit('update:replyShow', false)
    },
    save () { // 保存快捷回复
      if (this.status === 'add') { // 新增
        let params = {
          content: this.inputReply, // 内容
          templateType: this.group, // 类型，0：公共，1：私有
          createUser: this.myUserId
        }
        addReply(params).then(res => {
          this.$message.success('新增成功')
          this.getList()// 刷新
          this.showEdit = false
          this.status = 'edit'
        })
      } else { // 编辑
        let params = {
          id: this.currentRow.id, // 主键
          content: this.inputReply, // 内容
          templateType: this.group, // 类型，0：公共，1：私有
          templateSort: this.currentRow.templateSort // 排序
        }
        editReply(params).then(res => {
          this.$message.success('保存成功')
          this.getList()// 刷新
          this.showEdit = false
        })
      }
    },
    handleAdd () { // 添加回复
      this.showEdit = true
      this.status = 'add'
    },
    finish () { // 完成编辑
      this.status = 'detail'
    },
    deleteItem (val) { // 删除
      this.$confirm('确定要删除该快捷语句?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let params = {
          id: val.id
        }
        deleteReply(params).then(res => {
          this.$message.success('删除成功')
          this.getList()// 刷新
        })
      }).catch(() => {
        this.$message.info('已取消')
      })
    },
    addBack () { // 新增返回
      this.showEdit = false
      this.status = 'edit'
    }
  },
  beforeDestroy () {},
  destroyed () {}
}
</script>
<style lang='scss' scoped>
.reply-content{
    width:100%;
    height: 100%;
    position: fixed;
    top: 0;
    left:0;
    background-color: #fff;
    padding: 20px;
    box-sizing: border-box;
    i{
        font-size: 18px;
        cursor: pointer;
    }
}
.editContent{
    width:100%;
    height: 100%;
    position: fixed;
    top: 0;
    left:0;
    background-color: #fff;
    padding: 20px;
    box-sizing: border-box;
    z-index: 99;
}
.one-bar{
    margin-bottom: 10px;
    cursor: pointer;
    border-bottom: 1px solid #e9e9e9;
    padding-bottom: 10px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    i{
        font-size: 22px;
        cursor: pointer;
    }
    .color-red{
        color: #ef2020;
    }
    .color-gray{
        color:#d1d1d1
    }
    span{
        margin: 0 15px;
        width: 100%;
    }
}
.header{
    height: 30px;
    line-height: 30px;
    strong{
        font-size: 18px;
    }
}
.el-tabs{
   /deep/ .el-tabs__content{
        overflow: auto;
        height: calc(100vh - 90px);
    }
}
 .mb-10{
    margin-bottom: 10px;
}
.cursor{
    cursor: pointer;
}
.mr-10{
    margin-right: 10px;
}
.mt-10{
    margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// packages/chat/src/quickReply.vue